import React from 'react';
import { motion } from 'framer-motion';
interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  centered?: boolean;
}
export function SectionHeading({
  title,
  subtitle,
  centered = false
}: SectionHeadingProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} transition={{
    duration: 0.5
  }} className={centered ? 'text-center' : ''} data-id="element-425" data-mp="vxjlf97f6u9v">
      <h2 className="text-3xl md:text-4xl font-serif text-charcoal mb-3" data-id="element-426" data-mp="i6di1210schp">
        {title}
      </h2>
      <div className="w-16 h-1 bg-au-gold mb-4" style={{
      marginLeft: centered ? 'auto' : '0',
      marginRight: centered ? 'auto' : '0'
    }} data-id="element-427" data-mp="d9epgnx08dlm"></div>
      {subtitle && <p className="text-lg text-gray-600 max-w-2xl" style={{
      marginLeft: centered ? 'auto' : '0',
      marginRight: centered ? 'auto' : '0'
    }} data-id="element-428" data-mp="4a9n16ibo046">
          {subtitle}
        </p>}
    </motion.div>;
}